/* Sunkissed custom: "Complete the set" cart offers (design 4a — per-item).
   For EACH incomplete top/bottom in the cart (max 2, newest first), inserts a compact
   boxed offer directly under that item's line in the cart drawer: label + save badge,
   matching-piece thumb/title, shape + size dropdowns, Add. Candidates come from
   complementary recs -> related recs -> predictive search, filtered to the opposite
   piece in the same colorway; same-shape is preselected. Products re-fetched via
   /products/<handle>.js so prices/variants are canonical. An offer disappears the
   moment its set is completed or its item is removed. */
(function () {
  'use strict';
  var ITEM_SEL = '.cart__item[data-item]';
  var OFFER_CLASS = 'set-offer-inline';
  var MAX_OFFERS = 2;
  var SET_SAVING_CENTS = 2000; // "save $20" on the set; set to 0 to hide
  var busy = false;
  var offers = {}; // itemKey -> {handles, products, current, cartItem}

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function pieceOf(title) {
    if (/\bone[- ]?piece\b/i.test(title)) return null;
    if (/\btop\b/i.test(title)) return 'top';
    if (/\bbottom\b/i.test(title)) return 'bottom';
    return null;
  }
  function colorOf(title) {
    var i = title.lastIndexOf(' - ');
    return i > -1 ? title.slice(i + 3).trim().toLowerCase() : null;
  }
  function shapeOf(title) {
    var base = title.split(' - ')[0].replace(/\b(top|bottom)\b/i, '').replace(/^\s*(le|la|the)\s+/i, '').trim();
    return base || title;
  }
  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }
  function fetchJson(url) {
    return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function collectCandidates(cartItem, want, color, inCartHandles) {
    var recBase = '/recommendations/products.json?product_id=' + cartItem.product_id;
    var q = encodeURIComponent(want + (color ? ' ' + color : ''));
    var sources = [
      fetchJson(recBase + '&limit=10&intent=complementary'),
      fetchJson(recBase + '&limit=10&intent=related'),
      fetchJson('/search/suggest.json?q=' + q + '&resources[type]=product&resources[limit]=10')
    ];
    return Promise.all(sources).then(function (results) {
      var all = [];
      (results[0] && results[0].products || []).forEach(function (p) { all.push(p); });
      (results[1] && results[1].products || []).forEach(function (p) { all.push(p); });
      var sr = results[2] && results[2].resources && results[2].resources.results && results[2].resources.results.products;
      (sr || []).forEach(function (p) { all.push(p); });
      var seen = {};
      var out = [];
      all.forEach(function (p) {
        var title = p.title || '';
        var handle = p.handle || handleFromUrl(p.url);
        if (!handle || seen[handle]) return;
        seen[handle] = true;
        if (pieceOf(title) !== want) return;
        if (inCartHandles.indexOf(handle) > -1) return;
        if (color && colorOf(title) !== color) return;
        out.push({ handle: handle, title: title });
      });
      return out;
    });
  }

  function sizeList(prod) {
    var sizeOptIdx = -1;
    (prod.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (/size/i.test(name || '')) sizeOptIdx = i;
    });
    var sizes = [];
    (prod.variants || []).forEach(function (v) {
      sizes.push({ id: v.id, label: sizeOptIdx > -1 ? v['option' + (sizeOptIdx + 1)] : v.title, available: !!v.available });
    });
    return sizes;
  }

  function cartItemSize(cartItem) {
    var size = null;
    (cartItem.options_with_values || []).forEach(function (o) {
      if (/size/i.test(o.name)) size = o.value;
    });
    if (!size && cartItem.variant_title) size = cartItem.variant_title.split(' / ')[0];
    return size;
  }

  function renderOffer(itemKey) {
    var st = offers[itemKey];
    if (!st) return;
    var line = document.querySelector(ITEM_SEL.replace(']', '="' + itemKey + '"]'));
    if (!line) return;
    var prod = st.products[st.current];
    if (!prod) return;
    var allSizes = sizeList(prod);
    var sizes = allSizes.filter(function (s) { return s.available; });
    if (!sizes.length) return;

    var el = line.nextElementSibling;
    var prevSize = null;
    if (el && el.classList && el.classList.contains(OFFER_CLASS)) {
      var sel = el.querySelector('.sk-ol__size');
      if (sel && sel.selectedOptions[0]) prevSize = sel.selectedOptions[0].textContent;
    } else {
      el = document.createElement('div');
      el.className = OFFER_CLASS;
      line.parentNode.insertBefore(el, line.nextSibling);
    }
    var keepLabel = prevSize || cartItemSize(st.cartItem);
    var selected = sizes.filter(function (s) { return s.label === keepLabel; })[0] || sizes[0];

    var cap = prod.compare_at_price && prod.compare_at_price > prod.price ? prod.compare_at_price : null;
    var save = cap ? cap - prod.price : 0;
    var img = prod.featured_image || '';
    if (img && typeof img !== 'string') img = img.src || img.url || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var url = prod.url || ('/products/' + prod.handle);

    var shapeSelect = '';
    if (st.handles.length > 1) {
      shapeSelect =
        '<select class="sk-ol__select sk-ol__shape" aria-label="Style">' +
          st.handles.map(function (h) {
            return '<option value="' + h.handle + '"' + (h.handle === st.current ? ' selected' : '') + '>' + shapeOf(h.title) + '</option>';
          }).join('') +
        '</select>';
    } else {
      shapeSelect = '<a href="' + url + '" class="sk-ol__link">' + shapeOf(prod.title) + '</a>';
    }
    var unlocks = st.cartTotal != null && st.cartTotal < 10000 && (st.cartTotal + prod.price) >= 10000;

    // "Make it a set" card (CRO build 1c): pair preview + set price; compact for the 2nd offer
    var compact = false; // every offer gets the full pair card
    var cartImg = st.cartItem.image || '';
    if (cartImg && cartImg.indexOf('//') === 0) cartImg = 'https:' + cartImg;
    var wantPiece = pieceOf(prod.title) || 'piece';
    var setSave = SET_SAVING_CENTS > 0 ? SET_SAVING_CENTS : save;
    var setFull = st.cartItem.price + prod.price, setPrice = setFull - setSave;
    var squares = allSizes.map(function (s) {
      if (!s.available) return '<button type="button" class="sk-sq sk-ol__sq is-soldout" disabled aria-disabled="true" title="Sold out">' + s.label + '</button>';
      return '<button type="button" class="sk-sq sk-ol__sq' + (s.id === selected.id ? ' is-selected' : '') + '" data-ol-size="' + s.id + '" aria-pressed="' + (s.id === selected.id ? 'true' : 'false') + '">' + s.label + '</button>';
    }).join('');
    var soldOut = allSizes.filter(function (s) { return !s.available; }).map(function (s) { return s.label; });
    var soldOutNote = soldOut.length ? '<p class="sk-set__soldout">' + soldOut.join(', ') + ' sold out</p>' : '';
    var pair = compact ? '' :
      '<div class="sk-set__pair">' +
        '<div class="sk-set__piece sk-set__piece--owned">' + (cartImg ? '<img src="' + cartImg + (cartImg.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="">' : '<span class="sk-set__ph"></span>') + '<span>In your bag' + (cartItemSize(st.cartItem) ? ' \u00b7 ' + cartItemSize(st.cartItem) : '') + '</span></div>' +
        '<span class="sk-set__plus">+</span>' +
        '<a class="sk-set__piece" href="' + url + '">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="">' : '<span class="sk-set__ph"></span>') + '<span>' + prod.title.split(' - ')[0] + '</span></a>' +
      '</div>';
    el.innerHTML =
      '<div class="sk-set' + (compact ? ' sk-set--compact' : '') + '">' +
        '<div class="sk-set__head"><span class="sk-set__title">Make it a set</span><span class="sk-set__price">' + (setSave > 0 ? '<s>' + money(setFull).replace('.00', '') + '</s> ' : '') + '<strong>' + money(setPrice).replace('.00', '') + '</strong>' + (setSave > 0 ? ' <em>\u00b7 save ' + money(setSave).replace('.00', '') + '</em>' : '') + '</span></div>' +
        pair +
        (compact ? '<a class="sk-set__name" href="' + url + '">' + prod.title.split(' - ')[0] + '</a>' : '') +
        (st.handles.length > 1 ? '<div class="sk-set__style"><span class="sk-set__sizes-label">Style</span>' + shapeSelect + '</div>' : '') +
        '<div class="sk-set__sizes"><span class="sk-set__sizes-label">' + wantPiece.charAt(0).toUpperCase() + wantPiece.slice(1) + ' size</span><div class="sk-ol__sizes">' + squares + '</div></div>' +
        '<button type="button" class="sk-ol__add sk-set__add"><span>Complete my set</span><span>+ ' + money(prod.price).replace('.00', '') + (unlocks ? ' \u00b7 free shipping \u2713' : '') + '</span></button>' +
        '<select class="sk-ol__size" aria-hidden="true" tabindex="-1" style="display:none">' +
          sizes.map(function (s) { return '<option value="' + s.id + '"' + (s.id === selected.id ? ' selected' : '') + '>' + s.label + '</option>'; }).join('') +
        '</select>' +
      '</div>';
    Array.prototype.forEach.call(el.querySelectorAll('[data-ol-size]'), function (sq) {
      sq.addEventListener('click', function () {
        el.querySelector('.sk-ol__size').value = this.getAttribute('data-ol-size');
        Array.prototype.forEach.call(el.querySelectorAll('[data-ol-size]'), function (b) { var on = b === sq; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
    });

    var shapeEl = el.querySelector('.sk-ol__shape');
    if (shapeEl) {
      shapeEl.addEventListener('change', function () {
        var handle = this.value;
        if (st.products[handle]) { st.current = handle; renderOffer(itemKey); return; }
        fetchJson('/products/' + handle + '.js').then(function (p) {
          if (p) { st.products[handle] = p; st.current = handle; renderOffer(itemKey); }
        });
      });
    }
    el.querySelector('.sk-ol__add').addEventListener('click', function () {
      if (busy) return;
      busy = true;
      var btn = this;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(el.querySelector('.sk-ol__size').value, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          busy = false;
          if (res.ok) {
            delete offers[itemKey];
            el.parentNode && el.parentNode.removeChild(el);
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          } else {
            btn.textContent = (res.json && res.json.description) || 'Sold out';
          }
        })
        .catch(function () { busy = false; btn.textContent = 'Try again'; });
    });
  }

  function clearStale(validKeys) {
    Array.prototype.slice.call(document.querySelectorAll('.' + OFFER_CLASS)).forEach(function (el) {
      var prev = el.previousElementSibling;
      var key = prev && prev.getAttribute && prev.getAttribute('data-item');
      if (!key || validKeys.indexOf(key) === -1) el.parentNode.removeChild(el);
    });
  }

  function update() {
    if (!document.querySelector(ITEM_SEL)) { return; }
    fetchJson('/cart.js').then(function (cart) {
      if (!cart) return;
      var inCartHandles = cart.items.map(function (it) { return it.handle; });
      // newest first: Shopify puts most recently added items first in cart.items
      var candidates = [];
      cart.items.forEach(function (it) {
        var piece = pieceOf(it.product_title);
        if (!piece) return;
        var want = piece === 'top' ? 'bottom' : 'top';
        var color = colorOf(it.product_title);
        var covered = cart.items.some(function (other) {
          return pieceOf(other.product_title) === want && (!color || colorOf(other.product_title) === color);
        });
        if (!covered) candidates.push({ item: it, want: want, color: color });
      });
      // one offer per colorway (two rouge tops -> one rouge offer)
      var seenColor = {};
      candidates = candidates.filter(function (c) {
        var k = (c.color || c.item.product_id) + '|' + c.want;
        if (seenColor[k]) return false;
        seenColor[k] = true;
        return true;
      }).slice(0, MAX_OFFERS);

      var validKeys = candidates.map(function (c) { return c.item.key; });
      clearStale(validKeys);
      Object.keys(offers).forEach(function (k) { if (validKeys.indexOf(k) === -1) delete offers[k]; });

      candidates.forEach(function (c) {
        if (offers[c.item.key]) { offers[c.item.key].cartTotal = cart.total_price; renderOffer(c.item.key); return; }
        collectCandidates(c.item, c.want, c.color, inCartHandles).then(function (list) {
          if (!list.length) return;
          var cartShape = shapeOf(c.item.product_title).toLowerCase().split(' ')[0];
          list.sort(function (a, b) {
            var am = shapeOf(a.title).toLowerCase().indexOf(cartShape) === 0 ? -1 : 0;
            var bm = shapeOf(b.title).toLowerCase().indexOf(cartShape) === 0 ? -1 : 0;
            return am - bm;
          });
          var st = { handles: list.slice(0, 5), products: {}, cartItem: c.item, current: list[0].handle, cartTotal: cart.total_price };
          fetchJson('/products/' + st.current + '.js').then(function (prod) {
            if (!prod) return;
            st.products[st.current] = prod;
            offers[c.item.key] = st;
            renderOffer(c.item.key);
          });
        });
      });
    });
  }

  ['theme:cart:refresh', 'theme:cart:change', 'theme:cart:update', 'theme:cart-drawer:open', 'theme:product:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(update, 300); setTimeout(update, 1200); });
  });
  var mo = new MutationObserver(function (muts) {
    var external = muts.some(function (m) {
      var t = m.target;
      return !(t.closest && t.closest('.' + OFFER_CLASS));
    });
    if (!external) return;
    clearTimeout(mo.__t);
    mo.__t = setTimeout(update, 250);
  });
  function watch() {
    var drawer = document.querySelector('cart-drawer, [data-cart-drawer], .drawer--cart');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') { watch(); update(); }
  else document.addEventListener('DOMContentLoaded', function () { watch(); update(); });
})();
